import { useEffect, useState } from "react";
let A = [];
const TestImage = () => {
  let testA = Math.random();
  for (let index = 0; index < 1000; index++) {
    testA = testA + Math.random() + Math.random() * 1.23123;
  }
  A.push(testA);
  const memoryStatus = performance.memory;
  console.log("--mem--", memoryStatus);
  A = [...A, ...A];
  // console.log(A);
  return (
    <img src="https://aimg-1.kwcdn.com/upload_aimg/tree/temutree-75-squirrel-staging.png"></img>
  );
};

const displayMediaOptions = {
  video: {
    displaySurface: "browser",
  },
  audio: {
    suppressLocalAudioPlayback: false,
  },
  preferCurrentTab: false,
  selfBrowserSurface: "exclude",
  systemAudio: "include",
  surfaceSwitching: "include",
  monitorTypeSurfaces: "include",
};

async function startCapture(displayMediaOptions) {
  let captureStream;

  try {
    captureStream = await navigator.mediaDevices.getDisplayMedia(
      displayMediaOptions
    );
  } catch (err) {
    console.error(`Error: ${err}`);
  }
  return captureStream;
}

const Test = () => {
  const [showFrame, setShowFrame] = useState(0);
  const [showjumpIframe, setShowjumpIframe] = useState(0);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "10px",
      }}
    >
      <form id="form">
        <label>
          Test field: <input type="text" />
        </label>
        <br />
        <br />
        <input
          id="single-factor-code-text-field"
          autocomplete="one-time-code"
        />
        <br />
        <br />
        TEL：
        <input
          type="tel"
          name="smsvc"
          id="sms_verify_new-keyboardInputHidden"
        />
        <br />
        <br />
        Number:
        <input
          id="code"
          type="number"
          name="code"
          maxlength="6"
          class="account-form-input account-form-input-code "
          placeholder="验证码"
          tabindex="2"
        />
        <br />
        <br />
        <button type="submit">Submit form</button>
      </form>
      <p id="log"></p>
      <video controls width="250">
        <source
          src="https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm"
          type="video/webm"
        />
        <source
          src="https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4"
          type="video/mp4"
        />
        Download the
        <a href="https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm">
          WEBM
        </a>
        or
        <a href="https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4">
          MP4
        </a>
        video.
      </video>
      <input
        id="camera-input"
        type="file"
        accept="image/*"
        capture="environment" // 调用后置摄像头，如果想默认前置可以使用 capture="user"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            console.log("获取到照片:", file.name);
            // 可以在这里结合 URL.createObjectURL(file) 将图片显示在页面上
          }
        }}
      />
      
      <button
        onClick={() => {
          document.getElementById("camera-input").click();
        }}
      >
        拉起相机拍照
      </button>
      <audio
        controls
        src="https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3"
      ></audio>
      <a href="https://ideal.ing.nl/ideal/static/detect/ideal2_detect_mob">
        ING Applink
      </a>
      <a href="https://incomplete-chain.badssl.com/">
        incomplete-chain.badssl.com
      </a>
      <a href="http://fr-bou.view-sport.co/newseason">
        HTTPS TO HTTP
      </a>
      <a href="https://472cocs.top/co">
        Fraud!!!!!
      </a>
      <a href="http://tm.iii.sd">
        HTTP load self
      </a>
      <a href="https://x.com/shoptemu">
        X-SHOPTEMU
      </a>
      <a href="https://testsafebrowsing.appspot.com/s/malware.html">
        malware!!!!!
      </a>
      <a href="https://testsafebrowsing.appspot.com/s/phishing.html">
        phishing!!!!!
      </a>
      <a
        target="_blank"
        href="https://img.kwcdn.com/product-file-public/1e1918b4590/4c322550b533c1d942a1a178a57d8ac8.pdf"
      >
        PDF
      </a>
      <a
        href="https://apps.apple.com/app/id1641486558"
        target="_blank"
        rel="noopener noreferrer"
      >
        _blank apps.apple.com
      </a>

      <a
        href="https://maps.apple.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        _blank https://maps.apple.com
      </a>
        
      <a href="https://192.168.0.1" target="_blank" rel="noopener noreferrer">
        _blank https://192.168.0.1
      </a>
      <a
        href="https://192.168.2.1:3000"
        target="_blank"
        rel="noopener noreferrer"
      >
        _blank https://192.168.2.1:3000
      </a>
      <a href="http://172.20.10.12" target="_blank" rel="noopener noreferrer">
        TTTTTTTSSSSSS
      </a>
      <a href="https://192.168.0.1" rel="noopener noreferrer">
        https://192.168.0.1
      </a>
      <a href="http://192.168.2.1" rel="noopener noreferrer">
        http://192.168.2.1
      </a>
      <a
        href="https://apps.apple.com/app/id1641486558"
        rel="noopener noreferrer"
      >
        apps.apple.com
      </a>

      <a href="https://maps.apple.com" rel="noopener noreferrer">
        https://maps.apple.com
      </a>
      <a href="https://pay.dlocal.com/gmf-apm/payments-redirect/M-4a3abb24-5a8b-4919-b455-66355a06cec1">
        yape
    </a>
      <a href="https://www.google.com/bgt_paypal_orderpay_h5_callback.html?__bg_container_type=1&authSession=dhVH%2FAlQZwu4iIeXZOXvbbTPVc3igEgSs0yxplmRpN8%3D&can_use_unique_key=0&dr=211-en-USD&payAppId=6&payment_intent=pi_3OXPxPG9DQcOokn61J9fhGfi&payment_intent_client_secret=pi_3OXPxPG9DQcOokn61J9fhGfi_secret_aSl9C5Nxtr6WFn9FVJA2kde9T">
        Google query Test
      </a>
      <a href="itms-services://?action=download-manifest&url=https%3A%2F%2Fcd.pddpic.com%2Fvolantis-open%2Fios%2Fa8XHPy9TNn8FO2UmkLam.plist%3Fdigitalk%3DWbtcqapBkUC9iuqcqXAhhIx59DvoByql">
        download temu ws
      </a>
      <a href="https://www.temu.com/bgt_paypal_orderpay_h5_callback.html?__bg_container_type=1&authSession=dhVH%2FAlQZwu4iIeXZOXvbbTPVc3igEgSs0yxplmRpN8%3D&can_use_unique_key=0&dr=211-en-USD&payAppId=6&payment_intent=pi_3OXPxPG9DQcOokn61J9fhGfi&payment_intent_client_secret=pi_3OXPxPG9DQcOokn61J9fhGfi_secret_aSl9C5Nxtr6WFn9FVJA2kde9T">
        Temu query Test
      </a>
      <a href="https://gamemcu.com/su7/">MI SU7 3D</a>
      <input />
      <button onClick={() => setShowFrame(10)}> OOM </button>
      {showFrame === 10 && (
        <div>{Array(10000).fill(<TestImage />, 0, 10000)}</div>
      )}

      <a href="https://apple.com"> app store </a>
      <a href="https://jp.temu.com/bgt_no_callback.html"> bgt_no_callback </a>
      <a href="https://apps.apple.com/app/百度/123"> 中文字符 app store </a>
      <a href="https://apps.apple.com/app/id967040652"> AFFirm app store </a>
      <a href="https://affirm-alternate.app.link/73ISU4lljFb?__branch_flow_type=viewapp&__branch_flow_id=1267308907730032892&__branch_mobile_deepview_type=4&~journey_name=Mobile%20Interstitial%20on%20WWW&~journey_id=63cedb4aee83f20001019f50&~view_name=Interstitial&~view_id=1146146883917747212&_branch_match_id=1267308906900753235&referrer=link_click_id=1267308906900753235&utm_source=Website&utm_campaign=Mobile%20Interstitial%20on%20WWW&utm_medium=journeys&_t=1267308906900753235">
        Affirm
      </a>
      <a href="https://www.baidu.com">A 标签跳转</a>
      <a href="http:www.baidu.com">http:www.baidu.com</a>
      <a href="">空 A 标签跳转</a>
      <button
        onClick={() => {
          navigator.getUserMedia(
            { audio: true },
            () => {},
            () => {}
          );
        }}
      >
        麦克风权限1
      </button>
      <button
        onClick={() => {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then(function (stream) {
              stream.getAudioTracks()[0].stop();
            })
            .catch(function (err) {
              console.log("无法获取麦克风", err);
            });
        }}
      >
        麦克风权限2
      </button>
      <button
        onClick={() => {
          // 创建 Blob 对象
          const fileContent = "Hello, World!";
          const blob = new Blob([fileContent], { type: "text/plain" });

          // 创建一个临时 URL 指向 Blob 对象
          const url = window.URL.createObjectURL(blob);

          // 创建一个 a 标签并模拟点击
          const a = document.createElement("a");
          a.href = url;
          a.download = "filename.txt"; // 设置下载文件名
          a.click();

          // 释放临时 URL
          window.URL.revokeObjectURL(url);
        }}
      >
        Download
      </button>
      <button
        onClick={() => {
          if ("serviceWorker" in navigator) {
            console.log("serviceWorker!!");
          } else {
            console.log("no serviceWorker!!");
          }
          navigator.mediaDevices
            .enumerateDevices()
            .then((devices) => {
              devices.forEach((device) => {
                console.log(
                  `${device.kind}: ${device.label} id = ${device.deviceId}`
                );
              });
            })
            .catch((err) => {
              console.error(`${err.name}: ${err.message}`);
            });
          startCapture();
          navigator.mediaDevices.ondevicechange = (event) => {
            console.log("error");
          };
        }}
      >
        麦克风权限3
      </button>
      <input type="file" accept="video/*,.pdf" />
      <img src="https://aimg-1.kwcdn.com/upload_aimg/tree/temutree-75-squirrel-staging.png"></img>
      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "https://www.baidu.com";
        }}
      >
        href
      </button>

      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "https://cznull.github.io/vsbm";
        }}
      >
        毒蘑菇
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.assign("https://www.baidu.com");
        }}
      >
        href assign
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.replace("https://www.baidu.com");
        }}
      >
        Replace
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.reload();
        }}
      >
        reload
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "https://www.baidu.com?use_browser=1";
        }}
      >
        safari 跳转
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.open("https://www.baidu.com");
        }}
      >
        window open
      </button>
      <a href="https://api.vipps.no/dwo-api-application/v1/deeplink/vippsgateway?v=2&token=eyJraWQiOiJqd3RrZXkiLCJhbGciOiJSUzI1NiJ9.eyJhcGlTb3VyY2UiOiJQU1BWMyIsInN1YiI6ImYwMTQyYjFjLTZiMjAtNDUzYy1hOWYxLWUxZTBkYWI2OTM5NyIsIm1vYiI6IjQ3MTEyNTQzODEiLCJpc3MiOiJodHRwczpcL1wvVklQUFMtUFJPRC1DT04tQUdFTlQtaWxiLnRlY2gtMDIubmV0XC9kZWVwbGluay1vcGVuaWQtcHJvdmlkZXItYXBwbGljYXRpb25cLyIsInR5cGUiOiJQU1BfUEFZTUVOVCIsInRpdGxlIjoiMcKgMDU1IGtyIiwidXVpZCI6IjJhODFiMjVjLTNhYzgtNDU0Ni04OWQ2LWQwNTBkMzZiN2ViYiIsInJlZmVyZW5jZUlkIjoiNzE0MzIyNjciLCJhenAiOiJmMDE0MmIxYy02YjIwLTQ1M2MtYTlmMS1lMWUwZGFiNjkzOTciLCJhcHBUeXBlIjoiTEFORElOR1BBR0UiLCJub0VkaXQiOmZhbHNlLCJjdXJyZW5jeSI6Ik5PSyIsImV4cCI6MTcxMDg0MjI4OCwiaWF0IjoxNzEwODQxNjg5LCJicmFuZCI6IlZJUFBTIiwianRpIjoiYzhlNzNiMGYtOGYwYi00MmJiLWI0MWYtMmI5Y2I5NWFjZGIwIiwiYXBwIjoiZVBheW1lbnQiLCJhbW91bnQiOiIxMDU1MDAiLCJtZXJjaGFudFNlcmlhbE51bWJlciI6Ijg1MDQzNCIsIjFmYSI6InRydWUiLCJ1cmwiOiJodHRwczpcL1wvYXBpLnZpcHBzLm5vXC92aXBwcy1lcGF5bWVudC1sZWdhY3ktbW9iaWxlLWFwaVwvbGFuZGluZy1wYWdlIiwibWFya2V0IjoiTk8iLCJhdWQiOiJmMDE0MmIxYy02YjIwLTQ1M2MtYTlmMS1lMWUwZGFiNjkzOTciLCJzY29wZXMiOltdLCJ0b2tlblR5cGUiOiJERUVQTElOSyIsImZhbGxiYWNrIjoiaHR0cHM6XC9cL2NoZWNrb3V0c2hvcHBlci1saXZlLmFkeWVuLmNvbVwvY2hlY2tvdXRzaG9wcGVyXC9jaGVja291dFBheW1lbnRSZXR1cm4_Z3BpZD1HUEEzNjlDNjQ4MkQ1ODkzMDEmcj03MTQzMjI2NyJ9.eMYIvN3fUhmW4U8F009jeBpILIs5lu05J5wo7uJ27kkrWg_ehRDehSuHIysrluCO2jEf-FGaM_Jzqhy4vjg1RzuTAz3YUBEccHo083U4FcIn0WxkBCQ72Iw_1Itou5k_rVEkImh_HF_aI5ifII-fyri7piVcU2Frmkpk_iq6xCoMbaOw1kVdkDO6aVmmMoIdJuar1C-gAx8WMpSjCL3AbgWsoTnqkWKXDeskn_dU5hC7MWfSVuRINy-CBfET66fV96p39hRTSIiECGBKLeP7RfnxGViMJZtPJhL7-gLSmQZBIcoz3cFyyCLT2Y8w74bqgNhvjoaRLVU7j-5AVmV6cA">
        api.vipps.no Ulink
      </a>
      <a href="https://products.mobilepay.dk/remote-website/index.html?tpw_open_external_app=1">
        MobilePay Ulink2
      </a>
      <a href="https://products.mobilepay.dk/remote-website/index.html">
        MobilePay Ulink1
      </a>
      <a href="https://app.temu.com">ulink TEMU</a>
      <a href="https://oia.zhihu.com/answers/3503534750?open=1&utm_id=0&callback_source=others&fallback_url=https%3A%2F%2Foia.zhihu.com%2Fanswers%2F3503534750%3Futm_id%3D0%26callback_source%3Dothers">
        ulink ZHIHU
      </a>
      <a href="https://wa.me/972559728365">whatsapp jump 1</a>
      <a href="https://api.whatsapp.com/send/?phone=972559728365&text&type=phone_number&app_absent=0">
        whatsapp jump 2
      </a>
      <a href="https://eu.temu.com/bgn_verify_link.html?retryCount=3&verifyUrl=https%3A%2F%2Fproducts.mobilepay.dk%2Fremote-website%2Findex.html&bizType=default_stock">
        MobilePay ulink redirect
      </a>
      <a href="https://checkoutshopper-live.adyen.com/checkoutshopper/checkoutPaymentRedirect?redirectData=X3XtfGC7%21H4sIAAAAAAAA%2F4VUbU%2FbMBD%2BL5HGly3BTp23StUEbQelvFSsDG2qVDn2pTXkDccpqxD%2Ffee2wMZWLR%2Bi%2BO6e8z3P3eXJOclbqPkCBtxwp%2FvkpJqXsl9JcLpOUaUqR%2B%2Fa%2BeQIDdyAPDJo94nPXEJdEk9p2A1I16cfCe0SgnHws1Yamj%2Fjkr%2FjlMSAk0lM%2B%2BTLcDgI%2BglhNDpGTwFaLHlpjoSo2tLmmQ4vbtzhDfo0SMwuzISvCyjNS9G82EY%2BOaLVGkqxRtRgPEbEiiNBp5tEUfL8yeG1%2Bga6UVXpdMPEnutcCW7QMCqzapNLrqE8V6iDXttzyQurxcbs3vEVdzGJm%2B8C8IKXfA6NPeIR5xnv2auirVOvd57B%2BD90X3zXkIGlZUGUEGqFJZTEE0JCHz%2BipBMHCbFPxBBXabVQJc8nTf079PY0OvOj0yA4uz3tDILORtCHFhpzJKWyIvD8VdI%2FlfF2hC%2F%2Fo8Ye2Lf3Ir1xG5UGFnqD8My6ttn7p8P%2B%2BOpmOj8ZXg6vR%2F090W%2FKh4nzbLmYVpc3OkfL0pi66c4OZ4diCeK%2Bak2zrOoaNNa6Am9Tvyeq4i%2F%2Fm2E3Y9ebrJ8XtZK9f85rAzlOJMhj2%2FN3%2FW7uVblrdt2m3sr3%2FJCGIWUM4T5hLPSK%2FPqKTuld5yLMW8J42%2F8xImJyd3a16K8m55csuLhdFQ%2FZ1%2B%2FNluR2A97TrHUlW2Ea7%2FV6T97PDjUUlQH3EdJGGZgdqlLCT29pivyz3frerv8HSC4DJsIspm4gBHNZnMRujMPmEpAkkBH4ieAHPFe86X3wj1ng2wffzj7lofUMFO1W5nRh5jwzoOe8Ncu54HmecnG%2FLWU%2BTxdzUZWGqxIj7Bj06IGGOucC5lj8SsEjWsRyiiI3I9n7ekXsHmy2gAZhh3RI4iehT8PXJTAawTXH4bdLhUQki%2F1EkiiOEppmMmG%2BlD7v8JimMedJ4AaMsU4AgossEyQE%2FHfhNv8CBzXMCSQFAAA%3DQf9waOHG0t2ep%2B6s63juu16SO3CBuO9z3CGToSh%2B%2BZE%3D">
        MobilePay ulink redirect2
      </a>
      <a href="temu://com.einnovation.temu/bgt_after_auth_callback_browser.html?hash=64d24079e3406bc4eacb6f05a5f0289defc30e55b2570006&merchant_payment_code=101120230808470013500867010024&payment_type_code=webpay-rest&browser_callback=1">
        TEMU scheme 跳转
      </a>
      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "tel://123123123";
        }}
      >
        FaceTime
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "calshow://xxxxx";
        }}
      >
        日历
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.href = "weixin://xxxxx";
        }}
      >
        weixin
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "mobilenotes://xxxxx";
          const newWindow = window.open(url, "mobilenotes://xxxxx");
          window.close();
          setTimeout(() => {
            newWindow.close();
          }, 1000);
        }}
      >
        window.close jump
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "tiktok://xxxxx";
          const newWindow = window.open(url, "tiktok://xxxxx");
          window.close();
          setTimeout(() => {
            newWindow.close();
          }, 1000);
        }}
      >
        window.close jump TT
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "mobilenotes://xxxxx";
          const newWindow = window.open(url, "_blank");
          window.close();
        }}
      >
        window.closse calshow
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "tiktok://xxxxx";
          const newWindow = window.open(url, "_blank");
          window.close();
        }}
      >
        window.closse tiktok
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "calshow://xxxxx";
          const newWindow = window.open(url, "calshow://xxxxx");
          window.close();
          setTimeout(() => {
            newWindow.close();
          }, 1000);
        }}
      >
        window.close jump2
      </button>
      <button
        onClick={() => {
          console.log("ok");
          const url = "calshow://xxxxx";
          const newWindow = window.open(url, "_blank");
          window.close();
        }}
      >
        window.closse calshow2
      </button>
      <button
        onClick={() => {
          console.log("ok");
          window.location.assign("weixin://xxxxx");
        }}
      >
        window assign weixin jump
      </button>
      <button
        onClick={() => {
          setShowFrame(~showjumpIframe);
        }}
      >
        showjumpIframe change
      </button>
      {showjumpIframe && (
        <iframe
          frameborder={"0"}
          width={"1"}
          height={"1"}
          src={"mobilenotes://xxxxx"}
          sandbox={"allow-popups allow-popups-to-escape-sandbox"}
          onLoad={() => {
            console.log("temu:cookies " + document.cookie);
          }}
        />
      )}
      <button
        onClick={() => {
          setShowFrame(1 + showFrame);
        }}
        onDoubleClick={() => {
          setShowFrame(0);
        }}
      >
        iframe call itms-showFrame {showFrame}
      </button>
      <button
        onClick={() => {
          setShowFrame(1 + showFrame);
        }}
        onDoubleClick={() => {
          setShowFrame(0);
        }}
      >
        iframe call itms-showFrame {showFrame}
      </button>
      {showFrame === 1 && (
        <iframe
          frameborder={"0"}
          width={"1000"}
          height={"1000"}
          src={"https://google.com"}
          sandbox={"allow-popups allow-popups-to-escape-sandbox"}
          onLoad={() => {
            console.log("temu:cookies " + document.cookie);
          }}
        />
      )}
      {showFrame === 2 && (
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16138.686652174396!2d-73.8349155026368!3d40.74908737927266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26064c226e6c1%3A0x4bc556059b2a89ca!2sFlushing%2C%20NY%2011355!5e0!3m2!1sen!2sus!4v1703767593293!5m2!1sen!2sus"
          width={"1000"}
          height={"1000"}
          frameborder={"0"}
          allowfullscreen={""}
          loading={"lazy"}
          referrerpolicy={"no-referrer-when-downgrade"}
        ></iframe>
      )}
      {showFrame === 3 && (
        <iframe
          src="//player.bilibili.com/player.html?bvid=BV1ZC4y1v77G&cid=847343270&page=1"
          width={"100%"}
          height={"100%"}
          frameborder={"0"}
          class="video"
          allowfullscreen="true"
        >
          {" "}
        </iframe>
      )}
      {showFrame === 7 && (
        <iframe
          frameborder={"0"}
          width={"1000"}
          height={"1000"}
          src={"https://temu.com"}
          onLoad={() => {
            window.document.cookie = "testtemudydydy=testdydydy12123";
            console.log("temu:cookies " + document.cookie);
          }}
        />
      )}

      <div hidden={true}>
        {showFrame === 4 && <iframe src="itms-apps://" />}
        {showFrame === 5 && (
          <iframe src="https://iforgot.apple.com/password/verify/appleid" />
        )}
        {showFrame === 6 && (
          <iframe src="https://us.temu.com/bgn_verify_link.html?retryCount=3&verifyUrl=itms-apps%3A%2F%2F&bizType=default_stock" />
        )}
      </div>
      <div
        style={{
          height: 100,
        }}
      />
      <input />
      <input />
      <input />
      <input />
      <iframe id="myHardcodedFrame"></iframe>
    </div>
  );
};
function logSubmit(event) {
  log.textContent = `Form Submitted! Timestamp: ${event.timeStamp}`;
  event.preventDefault();
}
export default function App(props) {
  useEffect(() => {
    // (function () {
    //   document.body.addEventListener("click", function () {
    //     const target = event.target || event.srcElement;
    //     if (target.nodeName.toLocaleLowerCase() === "a") {
    //       console.log("当前点击的 a 标签: ", target);
    //       const url = target.getAttribute("href");
    //       window.alert("click a: " + url);
    //       window.webkit.messageHandlers.aLabelMessageHandler.postMessage(
    //         "click a: "
    //       );
    //     }
    //   });
    // })();
    const form = document.getElementById("form");
    const log = document.getElementById("log");
    form.addEventListener("submit", logSubmit);

    window.document.cookie = "testdydydy=testdydydy12123;domain=.temu.com";
    window.document.cookie = "testdydydynormal=testdydydy12123;domain=.csb.app";
    if (navigator.vibrate) {
      navigator.vibrate(2000);
    } else if (navigator.webkitVibrate) {
      navigator.webkitVibrate(2000);
    } else {
      console.log("no vibrate");
    }
    var battery =
      navigator.battery || navigator.webkitBattery || navigator.mozBattery;
    console.log(battery);
  });

  useEffect(() => {
    // 您想要硬编码到 iframe 中的 HTML 内容
    const hardcodedHTML = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>硬编码内容</title>
    <style>
      body { font-family: sans-serif; margin: 20px; background-color: #f0f0f0; }
      h1 { color: navy; }
      p { color: #333; }
    </style>
  </head>
  <body>
    <h1>这是一个固定写死的内容</h1>
    <p>此内容通过 JavaScript 动态写入 iframe，其 URL 通常为 about:blank。</p>
    <p>当前时间: <span id="time"></span></p>
    <script>
      document.getElementById('time').innerText = new Date().toLocaleTimeString();
    <\/script>
  </body>
  </html>
`;

    // 获取 iframe 元素
    const iframeElement = document.getElementById("myHardcodedFrame");

    // 确保 iframe 加载完成后再写入内容
    // 对于没有 src 或 src="about:blank" 的 iframe，它会很快准备好
    // 使用 onload 是一个更稳妥的方式，确保 contentWindow 可用

    // 获取 iframe 的 document 对象
    const iframeDoc = iframeElement.contentWindow.document;

    // 打开文档流以写入内容
    iframeDoc.open();
    // 写入 HTML 内容
    iframeDoc.write(hardcodedHTML);
    // 关闭文档流，这将导致浏览器渲染写入的内容
    iframeDoc.close();

    // 如果 iframe 没有 src 属性，它会默认加载 about:blank
    // 如果您想确保，可以明确设置:
    // iframeElement.src = "about:blank"; // 如果JS在iframe标签之前，或者想重置它

    // 如果 iframe 是静态添加到 HTML 中的，且没有 src，
    // onload 事件可能已经触发或即将触发。
    // 如果 iframeElement.contentWindow 已经存在，也可以直接写入，
    // 但 onload 更安全。
    if (!iframeElement.src && iframeElement.contentWindow) {
      // 对于某些情况，如果iframe已经加载了about:blank，可以直接操作
      // 但为了统一和安全，建议还是通过 onload
    }
  });
  return (
    <div
      className="App"
      style={{
        textAlign: "center",
      }}
    >
      <h1>TEEMOO TEST</h1>
      <Test />
    </div>
  );
}
